import { render, staticRenderFns } from "./communicationList.vue.vue?vue&type=template&id=465b2be8&scoped=true&"
import script from "./communicationList.vue.vue?vue&type=script&lang=js&"
export * from "./communicationList.vue.vue?vue&type=script&lang=js&"
import style0 from "./communicationList.vue.vue?vue&type=style&index=0&id=465b2be8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465b2be8",
  null
  
)

export default component.exports